export default __webpack_public_path__ + "static/media/Yellow.fb9448c0.png";